export default {
  name: 'visitorsMixin',
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    currentCompany() {
      const companyName = this.$store.getters.companyKey || 'any';
      if (Object.keys(this.$options.components).includes(companyName)) {
        return companyName;
      }
      return 'any';
    },
  },
  async created() {
    this.loading = true;

    // get landingpage data
    await this.$store.dispatch('getUiSettings', false);

    await this.$nextTick();

    this.loading = false;
  },
};
